import { DatePicker, Input, Table, Modal, Button, InputNumber } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate, coinDivideFormat, coinMultiFormat } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const paymentStatusCode = ['SCHEDULE', 'COMPLETE', 'CANCEL'];
const paymentStatusString = {
  SCHEDULE: '배당예정',
  COMPLETE: '배당완료',
  CANCEL: '배당취소',
}
class BbtAirdrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      pagination: {
        total: 0,
        current: 1
      },
      createVisible: false,
      createAirdropDate: '',
      selectedRow: "",
      selectedAirdropDate: "",
      selectedAmount: ""
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.bbtAirdropList,[10,pageNum],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };

  create = () => {
    if (!this.state.createAirdropDate || this.state.createAirdropDate.length != 8) {
      alert('분배일자를 8자로 입력해주세요.')
      return;
    }
    httpPost(httpUrl.bbtAirdropCreate, [], {
      airdropDate: this.state.createAirdropDate,
      status: 'SCHEDULE',
      amount: 0
    }).then(res => {
      if (res.data) {
        this.setState({createVisible: false})
        this.getList();
      } else {
        alert('생성에 실패하였습니다. 이미 예약된 일자가 있는지 확인해주세요.')
      }
    });
  }

  modify = () => {
    if (!this.state.selectedAmount || isNaN(this.state.selectedAmount)) {
      alert('수량을 숫자로 입력해주세요.')
      return;
    }
    httpPost(httpUrl.bbtAirdropModify, [], {
      airdropDate: this.state.selectedAirdropDate,
      amount: coinMultiFormat(this.state.selectedAmount, 402)
    }).then(res => {
      if (res.data) {
        this.setState({
          selectedRow: "",
          selectedAirdropDate: "",
          selectedAmount: "",
        }, ()=>this.getList());
        
      } else {
        alert('수정에 실패하였습니다.')
      }
    });
  }
  delete = (airdropDate) => {
    if (global.confirm(airdropDate + ' 배당을 삭제하시겠습니까?'))
      httpPost(httpUrl.bbtAirdropDelete, [airdropDate], {}).then(res => {
        if (res.data) {
          this.getList();
          
        } else {
          alert('삭제에 실패하였습니다.')
        }
      });
    
  }
  cancel = (airdropDate) => {
    if (global.confirm(airdropDate + ' 배당을 취소하시겠습니까? 취소하는 경우 배당금이 사용자에게서 다시 회수됩니다.'))
      httpPost(httpUrl.bbtAirdropCancel, [airdropDate], {}).then(res => {
        if (res.data) {
          this.getList();
          
        } else {
          alert('취소에 실패하였습니다.')
        }
      });
    
  }
  render() {
    const { tables } = this.state;
    const columns = [
      {
        title: "분배일자",
        dataIndex: "airdropDate",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "상태",
        dataIndex: "status",
        className: "support-column-number fs-15 lh-21",
        render: data => paymentStatusString[data]
      },
      {
        title: "배당할 총 수량",
        dataIndex: "amount",
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
          <div>
            {this.state.selectedRow !== index ? (
              amountFormat(data, 402)
            ) : (
              <InputNumber
                min={0}
                max={coinDivideFormat(9223372036854775807, 402)}
                style={{ width: "180px" }}
                value={this.state.selectedAmount}
                onChange={value => {
                  this.setState({selectedAmount: value})
                }}
              />
            )}
          </div>
        )
      },
      {
        title: "총 동결수량",
        dataIndex: "totalStake",
        className: "support-column-number fs-15 lh-21",
        render: data => amountFormat(data, 401)
      },
      {
        title: "설정",
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
          <div>
            {this.state.selectedRow !== index && (
              <div>
              {row.status == 'SCHEDULE' && (
                <Button
                  onClick={() => {
                    this.setState({
                      selectedRow: index,
                      selectedAirdropDate: row.airdropDate,
                      selectedAmount: amountFormat(row.amount, 402)
                    });
                  }}>
                  수정하기
                </Button>
              )}
              </div>
            )}
            {this.state.selectedRow === index && (
              <div>
                <Button
                  style={{ marginRight: "8px" }}
                  type="primary"
                  shape="circle"
                  icon="check"
                  onClick={this.modify}
                />
                <Button
                  type="danger"
                  shape="circle"
                  icon="close"
                  onClick={() => {
                    this.setState({
                      selectedRow: "",
                      selectedAirdropDate: "",
                      selectedAmount: "",
                    });
                  }}
                />
              </div>
            )}
          </div>
        )
      },
      {
        title: "작업",
        dataIndex: "airdropDate",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => 
        <div>
              {row.status == 'SCHEDULE' && (
                <Button
                  type="danger"
                  onClick={() => this.delete(data)}>
                  삭제
                </Button>
              )}
              {row.status == 'COMPLETE' && (
                <Button
                  type="primary"
                  onClick={() => this.cancel(data)}>
                  취소
                </Button>
              )}
              </div>
      },
    ];
    

    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          
          <div className="flex-row flex-center flex-end m-b-10">
            <Button onClick={()=>{this.setState({createVisible: true})}} style={{marginRight: 10}}>배당일정생성</Button>
          </div>
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
            
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.status == 'COMPLETE' ? "blue" : record.status == 'CANCEL' ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
        <Modal
          visible={this.state.createVisible}
          title="신규 분배일 생성"
          okText="생성"
          cancelText="취소"
          onOk={this.create}
          onCancel={()=>this.setState({createVisible: false})}
          style={{ minWidth: "200px" }}>
          <Input
            allowClear
            value={this.state.createAirdropDate}
            onChange={e =>
              this.setState({createAirdropDate: e.target.value})
            }
            style={{ width: "100%" }}
            placeholder="분배일자를 8자로 입력해주세요(ex, 20240705)"
          />
        </Modal>
      </div>
    );
  }
}

export default BbtAirdrop;
